import getWithToken from './base/get-with-token'

const getHighUsageCustomer = (date, searchData) => getWithToken(`/dashboard/high-usage-customer?date=${date}`)(searchData)

export default getHighUsageCustomer